/* global  */ // tUrl等のグローバル変数を宣言する
/* global  AjaxZip3 */
import Swiper from 'swiper' // Swiper
import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  if ($('.js-index_news_scroll')[0]) {
    // eslint-disable-next-line no-unused-vars
    const ps = new PerfectScrollbar('.js-index_news_scroll')
  }

  $('.news__nav__select').on('change', function() {
    const value = $(this).val()
    console.log('value: ' + value)
    location.href = value
  })

  /*
        ######  ##      ## #### ########  ######## ########
       ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
       ##       ##  ##  ##  ##  ##     ## ##       ##     ##
        ######  ##  ##  ##  ##  ########  ######   ########
             ## ##  ##  ##  ##  ##        ##       ##   ##
       ##    ## ##  ##  ##  ##  ##        ##       ##    ##
        ######   ###  ###  #### ##        ######## ##     ##
*/
  if ($('#mv-slider')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const headerSwiper = new Swiper('#mv-slider', {
      effect: 'slide', // slide,fade,cube,coverflow
      loop: true,
      autoplay: {
        delay: 5000
      },
      speed: 1500, // アニメ速度
      navigation: {
        nextEl: '.swiper-button-next', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev' // 次のページボタンを呼び出す要素
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {}
      }
    })
  }

  /*
  ##     ##  #######  ########     ###    ##
  ###   ### ##     ## ##     ##   ## ##   ##
  #### #### ##     ## ##     ##  ##   ##  ##
  ## ### ## ##     ## ##     ## ##     ## ##
  ##     ## ##     ## ##     ## ######### ##
  ##     ## ##     ## ##     ## ##     ## ##
  ##     ##  #######  ########  ##     ## ########
*/
  $('.js-modal-adviser').on('click', function() {
    const index = $(this).index()
    openModal($('.team__modal__item').eq(index))
    return false
  })
  let scrollTop
  // モーダル開く
  function openModal(el) {
    let elModal = el.children('.team__modal__wrapper')
    let elModalContent = elModal.children('.team__modal__wrapper')
    scrollTop = $(window).scrollTop()
    elModal.addClass('active')
    elModal.scrollTop(0)
    $('body').addClass('modalOn')
    $('body').css({ top: -1 * scrollTop })
    if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
      for (let i = 0; i < elModalContent.length; i++) {
        elModalContent[i].addEventListener(
          'touchmove',
          function(e) {
            const scroll = elModalContent.scrollTop
            const range = elModalContent.scrollHeight - elModalContent.offsetHeight - 1
            if (scroll < 1) {
              e.preventDefault()
              elModalContent.scrollTop = 1
            } else if (scroll > range) {
              e.preventDefault()
              elModalContent.scrollTop = range
            }
          },
          { passive: false }
        )
      }
    }
  }
  // モーダル閉じる
  $('.team__modal__close').on('click', function() {
    closeModal($(this).closest('.team__modal__wrapper'))
  })
  $('.team__modal__wrapper').on('click', function() {
    closeModal($(this))
  })
  $('.team__modal__content').on('click', function(e) {
    e.stopPropagation()
  })
  function closeModal(el) {
    el.removeClass('active')
    $('body').removeClass('modalOn')
    $(window).scrollTop(scrollTop)
  }

  /*
  ##       ######  #######  #####  ######
  ##      ##    ##    ###  ##   ## ##   ##
  ##      ##    ##   ###   ####### ##   ##
  ##      ##    ##  ###    ##   ## ##   ##
  #######  ######  ####### ##   ## ######
  */
  /* global lozad */
  lozad('.lozad', {
    rootMargin: '3%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  // AjaxZip3
  if ($('#zipsearch')[0]) {
    $('#zipsearch').on('click', function() {
      $('input[name=zip]').each(function() {
        // 「zip」の郵便番号で見つけた住所を「address」に挿入
        AjaxZip3.zip2addr(this, '', 'address', 'address')
      })
    })
  }
})
